import React from 'react';

import { Box, ButtonBase } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Skeleton } from '@material-ui/lab';

import { numberWithCommas } from 'utils/lib';

const useStyles = makeStyles((theme) => ({

}));

// TODO: ADD VARIANTS FOR BOTTOM RIGHT ACTION?
export interface Props {
  title: string | React.ReactNode;
  stat?: number;
  icon: React.ReactNode;
  onViewAllClick?: () => void;
  boxSx?: object;
}

export default ({
  title, stat, icon, onViewAllClick, boxSx,
}: Props) => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Box sx={{
      width: 260,
      height: 160,
      padding: 24,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      borderRadius: 8,
      bgcolor: theme.palette.offWhite.main,
      ...(boxSx || {}),
    }}
    >
      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'start',
        alignItems: 'start',
      }}
      >
        {icon}
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          marginLeft: 14,
          fontWeight: 500,
          color: theme.palette.purple.dark,
        }}
        >
          <div style={{ fontSize: 14 }}>
            {title}
          </div>
          {stat !== undefined
            ? (
              <div style={{ marginTop: 5, fontSize: 24, fontWeight: 600 }}>
                {numberWithCommas(stat)}
              </div>
            )
            : <Skeleton variant="text" height={50} width={75} />}
        </Box>
      </Box>
      {onViewAllClick && (
        <Box sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
        >
          <ButtonBase onClick={onViewAllClick} style={{ color: theme.palette.primary.main }}>
            View All
            <ChevronRightIcon />
          </ButtonBase>

          {/* TODO: IMPLEMENT */}
          {/* <div>TODO</div> */}
        </Box>
      )}
    </Box>
  );
};
